class StudioProjects extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-ready')) return;
    this.setAttribute('data-ready', '');
    this.setView('strip');
    this.addEventListener('click', this.#onClick);
    document.addEventListener('keydown', this.#onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    document.removeEventListener('keydown', this.#onKeyDown);
    this.removeAttribute('data-ready');
  }

  #onKeyDown = (event) => {
    if (event.key === 'Escape') this.goBack();
  };

  #onClick = (event) => {
    const back = event.target.closest('[data-projects-back]');
    if (back) {
      if (this.dataset.view === 'strip') return;
      event.preventDefault();
      this.goBack();
      return;
    }

    const cover = event.target.closest('[data-project]');
    if (cover && this.contains(cover)) {
      event.preventDefault();
      this.openProject(cover.getAttribute('data-project'));
      return;
    }

    const thumb = event.target.closest('[data-gallery-src]');
    if (thumb && this.contains(thumb)) {
      event.preventDefault();
      this.openLarge(thumb);
    }
  };

  setView(view) {
    this.dataset.view = view;
  }

  setTitle(text) {
    const title = this.querySelector('[data-projects-title]');
    if (!title) return;
    title.textContent = text || this.dataset.pageTitle || '';
  }

  openProject(id) {
    const safeId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id;
    const template = this.querySelector(`[data-project-gallery="${safeId}"]`);
    const gallery = this.querySelector('[data-projects-gallery]');
    if (!template || !gallery) return;

    const cover = this.querySelector(`[data-project="${safeId}"]`);
    this.setTitle(cover?.getAttribute('data-project-title') || this.dataset.pageTitle);
    gallery.replaceChildren(template.content.cloneNode(true));
    this.setView('gallery');
  }

  openLarge(thumb) {
    const image = this.querySelector('[data-projects-large-image]');
    const src = thumb.getAttribute('data-gallery-src');
    if (!image || !src) return;

    image.src = src;
    image.alt = thumb.getAttribute('data-gallery-alt') || '';

    const body = this.querySelector('[data-projects-large-body]');
    if (body) {
      const projectId = thumb.getAttribute('data-project-id') || '';
      const safeId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(projectId) : projectId;
      const copy = projectId ? this.querySelector(`[data-project-copy="${safeId}"]`) : null;
      body.replaceChildren();
      if (copy) body.appendChild(copy.content.cloneNode(true));
      body.hidden = !copy || body.textContent.trim() === '';
    }

    this.setView('large');
  }

  goBack() {
    const view = this.dataset.view;
    if (view === 'large') {
      const image = this.querySelector('[data-projects-large-image]');
      if (image) image.removeAttribute('src');
      this.setView('gallery');
      return;
    }

    const gallery = this.querySelector('[data-projects-gallery]');
    if (gallery) gallery.replaceChildren();
    this.setTitle(this.dataset.pageTitle);
    this.setView('strip');
  }
}

if (!customElements.get('studio-projects')) {
  customElements.define('studio-projects', StudioProjects);
}
